import { useRef, useState } from 'react';
import { alpha, useTheme } from '@material-ui/core/styles';
import { Typography, ButtonBase, Grid } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
// components
import MenuPopover from '../../components/MenuPopover';
import { MIconButton } from '../../components/@material-extend';
import useAuth from '../../hooks/useAuth';

// ----------------------------------------------------------------------

export const FACILITIES = [
  { id: '14', name: 'Dark mode Qasmia' },
  { id: '13', name: 'Dark mode Mahatta' },
  { id: '10', name: 'Al Ikhtayar Al Qasmia' },
  { id: '7', name: 'Al Ikhtayar Al Mahatta' },
  { id: '11', name: 'Test Facility' },
];



export default function FacilitySelector({ isDarkModeFacility }) {
  const anchorRef = useRef(null);
  const theme = useTheme();
  const { user, selectedFacility, setSelectedFacility } = useAuth();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSelect = async (id) => {
    await setSelectedFacility(id);
    handleClose();
    window.location.reload();
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          width: { xs: 36, sm: 44 },
          height: { xs: 36, sm: 44 },
          color: isDarkModeFacility ? 'common.black' : 'text.primary',
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <HomeIcon color="inherit" />
      </MIconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{
          p: 2,
          width: 560, // Increased width to accommodate 4 items in a row
          maxWidth: '95vw'
        }}
      >
        <Grid container spacing={2}>
          {(() => {
            const rawIds = user?.staffFacilityIds || user?.staff_facility_ids;
            const allowedFacilities = rawIds ? String(rawIds).split(',') : null;
            const visibleFacilities = allowedFacilities ? FACILITIES.filter(f => allowedFacilities.includes(f.id)) : FACILITIES;
            
            return visibleFacilities.map((facility) => {
            const isSelected = facility.id === selectedFacility;

            return (
              // xs={3} creates 4 columns (12 / 3 = 4)
              <Grid item xs={3} key={facility.id}>
                <ButtonBase
                   onClick={() => handleSelect(facility.id)}
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 2,
                    px: 1,
                    borderRadius: 2,
                    transition: theme.transitions.create('all'),
                    ...(isSelected ? {
                      bgcolor: '#009fdb', // Bright blue matching your screenshot
                      color: 'common.white',
                      boxShadow: theme.customShadows?.z12 || theme.shadows[12],
                    } : {
                      color: 'text.secondary',
                      '&:hover': {
                        bgcolor: alpha(theme.palette.action.hover, 0.08)
                      }
                    })
                  }}
                >
                  <HomeIcon
                    sx={{
                      fontSize: 32,
                      mb: 1,
                      color: isSelected ? 'common.white' : '#212b36' // Darker icon for inactive
                    }}
                  />

                  <Typography
                    variant="caption"
                    align="center"
                    sx={{
                      fontWeight: 'bold',
                      lineHeight: 1.2,
                      fontSize: '0.725rem',
                      color: 'inherit'
                    }}
                  >
                    {facility.name}
                  </Typography>
                </ButtonBase>
              </Grid>
            );
          })
          })()}
        </Grid>
      </MenuPopover>
    </>
  );
}